module.exports = __webpack_public_path__ + "fonts/iconfont.da444a23.woff2";